import { PartState } from '../types';

export const thinkingState: PartState = {
	antenna1: {
		path: 'M169.775 68.3958C172.267 59.5915 181.836 41.8831 200.175 41.4844',
		tip: { cx: 201.172, cy: 41.4836, r: 4.48524 },
	},
	antenna2: {
		path: 'M127.415 68.3958C129.907 59.5915 139.475 41.8831 157.815 41.4844',
		tip: { cx: 157.316, cy: 41.4836, r: 4.48524 },
	},
	body: { x: 101.5, y: 62.4141, width: 99.6721, height: 161.469, rx: 31.8951 },
	bodyHighlight:
		'M182.234 79.3589C170.92 65.4945 140.508 61.75 130.405 61.418C209.678 61.418 205.792 61.418 212.009 139.116C216.652 197.139 194.949 220.554 186.351 222.333C185.418 222.526 184.721 221.732 184.721 220.779C184.73 179.007 194.687 94.6181 182.234 79.3589Z',
	stripes: { y1: 140.158, y2: 169.062, y3: 197.969, height: 14.9508 },
	eyes: { y: 91.293, leftX: 112.138, rightX: 149.623, width: 10.1312, height: 16.2099, rx: 5.0656 },
	wing1Path:
		'M200.476 80.9972L174.921 118.52C173.405 120.745 172.559 123.358 172.482 126.049C172.261 133.826 178.386 140.31 186.163 140.532L188.721 140.605C191.15 140.674 193.565 140.21 195.796 139.247L228.755 125.011C230.896 124.086 232.921 122.914 234.79 121.518L240.444 117.295C248.081 111.592 252.144 102.284 251.133 92.8064C249.493 77.4305 235.296 66.5728 220.027 69.0171L219.108 69.1641C211.534 70.3766 204.794 74.6571 200.476 80.9972Z',
	wing2Path:
		'M220.524 107.366L182.505 132.178C180.251 133.649 178.465 135.736 177.36 138.191C174.165 145.285 177.326 153.626 184.42 156.82L186.753 157.871C188.969 158.869 191.376 159.37 193.806 159.338L229.705 158.87C232.037 158.839 234.358 158.536 236.619 157.966L243.463 156.242C252.705 153.914 260.035 146.883 262.746 137.746C267.144 122.921 258.213 107.439 243.178 103.825L242.274 103.607C234.815 101.814 226.948 103.174 220.524 107.366Z',
	arms: [
		{ d: 'M101.5 151.065L126.334 132.322', side: 'left' },
		{ d: 'M196.227 142.747L220.758 161.884', side: 'right' },
	],
	stinger:
		'M194.251 243.237C192.218 240.358 190.597 235.619 189.46 231.143C188.549 227.554 184.606 225.475 181.261 227.062C178.496 228.374 177.311 231.723 179.308 234.042C183.222 238.587 188.95 241.979 193.577 244.069C194.578 244.521 194.884 244.134 194.251 243.237Z',
};
